__turbopack_context__.v({
  "button": "black-module-scss-module__E-biwa__button" + " " + __turbopack_context__.i(693367)["block"],
  "complete": "black-module-scss-module__E-biwa__complete" + " " + __turbopack_context__.i(693367)["complete"],
  "medium": "black-module-scss-module__E-biwa__medium" + " " + __turbopack_context__.i(693367)["medium"],
  "playing": "black-module-scss-module__E-biwa__playing" + " " + __turbopack_context__.i(693367)["playing"],
  "small": "black-module-scss-module__E-biwa__small" + " " + __turbopack_context__.i(693367)["small"],
});
